module.exports = __webpack_public_path__ + "static/noticias-16-8a807a857baab1dea0935536d86275fc.png";